module.exports = __webpack_public_path__ + "static/media/191IT203.8ea015eb.jpg";